import { CalendarPlus, Lightning, Airplane } from "@phosphor-icons/react";

const OPTS = [
  { v: "intervention", label: "Chantier", icon: CalendarPlus, color: "#005CFF" },
  { v: "depannage", label: "Dépannage", icon: Lightning, color: "#F59E0B" },
];

const LEAVE_OPT = { v: "leave", label: "Congé", icon: Airplane, color: "#10B981" };

/**
 * Segmented control for event kind. 2 options by default (intervention / dépannage);
 * pass `withLeave` to add a 3rd "Congé" chip that swaps the enclosing dialog into
 * leave-request mode (POST /leave-requests).
 */
export default function InterventionTypeToggle({ value, onChange, testid = "iv-type-toggle", withLeave = false }) {
  const current = value || "intervention";
  const opts = withLeave ? [...OPTS, LEAVE_OPT] : OPTS;
  const cols = withLeave ? "grid-cols-3" : "grid-cols-2";
  return (
    <div className={`grid ${cols} gap-2`} data-testid={testid}>
      {opts.map((o) => {
        const on = current === o.v;
        const Icon = o.icon;
        return (
          <button
            key={o.v}
            type="button"
            onClick={() => onChange(o.v)}
            className={`h-10 rounded-xl border flex items-center justify-center gap-1.5 text-xs font-semibold transition-all ${
              on ? "text-white" : "bg-white/5 border-white/10 text-white/60 hover:border-white/25"
            }`}
            style={on ? { background: o.color + "22", borderColor: o.color, color: "#fff" } : {}}
            data-testid={`${testid}-${o.v}`}
          >
            <Icon size={13} weight={on ? "fill" : "duotone"} style={on ? { color: o.color } : {}} />
            {o.label}
          </button>
        );
      })}
    </div>
  );
}

export const INTERVENTION_TYPE_META = {
  intervention: { label: "Chantier", color: "#005CFF", icon: "🏗️" },
  depannage: { label: "Dépannage", color: "#F59E0B", icon: "⚡" },
  leave: { label: "Congé", color: "#10B981", icon: "✈️" },
};
